import { axios } from '@/utils/request'
import ipConfig from '@../../../config/ip.config'

export const getOceanImportPageList = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanImport/GetOceanImportPageList`,
  method: 'get',
  params: query
})

export const getDataStatistics = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanImport/GetDataStatistics`,
  method: 'get',
  params: query
})

export const getBusinessStatisticsTotal = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanImport/GetBusinessStatisticsTotal`,
  method: 'get',
  params: query
})

export const getBusinessStatisticsCBMTotal = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanImport/GetBusinessStatisticsCBMTotal`,
  method: 'get',
  params: query
})

export const getAllFileListByBookingNo = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanImport/GetAllFileListByBookingNo`,
  method: 'get',
  params: query
})
